

























import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import PlanningSelector from '@/components/selectors/Planning/PlanningSelector.vue';
import IInbound from '@/store/models/IInbound';
import IOutbound from '@/store/models/IOutbound';
import InboundApi from '@/store/api/InboundApi';
import OutboundApi from '@/store/api/OutboundApi';
import IInboundDetail from '@/store/models/IInboundDetail';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import InboundDetailsApi from '@/store/api/InboundDetailApi';
import OutboundDetailsApi from '@/store/api/OutboundDetailApi';
import ListStatusInboundsApi from '../store/api/ListStatusInboundsApi';
import IListStatusInbound from '@/store/models/IListStatusInbound';
import ListStatusOutboundsApi from '../store/api/ListStatusOutboundsApi';
import IListStatusOutbound from '@/store/models/IListStatusOutbound';
import moment from 'moment';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import { TimeSlotCalculator } from '../components/shared/TimeSlotCalculator';
@Component({
    components: {
        Snackbar,
        PlanningSelector
    }
})
export default class Planning extends Vue {
    // PersonSelector
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    inboundsApi : InboundApi;
    inboundDetailApi : InboundDetailsApi;
    outboundDetailApi : OutboundDetailsApi;
    outboundsApi: OutboundApi;
    inboundList : IInbound[] = [];
    outboundList : IOutbound[] = [];
    inboundDetailList : IInboundDetail[] = [];
    outboundDetailList : IOutboundDetail[] = [];
    availableTimeSlots : number[] = [];
    selectedInbound: IInbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        containerNumber: "",
        sealNumber: "",
        weight: 0,
        liters: 0,
        referenceInboundCode: "",
        orderNumber: "",
        startTime: 7,
        endTime: 0,
        dateChanged: false,
        totalValue: 0,
        agp: "",
        arrivalFrom: "",
        codeDestination: "",
        idListTypesInbounds: "",
        listTypesInboundsName: "",
        idListCurrency: "",
        listCurrencyName: "",
        statusColor: "",
        arrivalFromCountry: ""
    };
    selectedOutbound : IOutbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateOut: new Date(),
        dossierNumber: "",
        weight: 0,
        liters: 0,
        deliveriesNumber: 0,
        description: "",
        containerNumber: "",
        sealNumber: "",
        orderNumber: "",
        startTime: 7,
        endTime: 0,
        dateChanged: false,
        entrepot: "",
        agp: "",
        referenceInboundCode: "",
        createdDate: new Date(),
        customerDestination: "",
        codeDestination: "",
        idListTypesOutbounds: "",
        listTypesOutboundsName: "",
        statusColor: "",
        customerDestinationCountry: ""
    };
    listStatusInboundsApi : ListStatusInboundsApi;
    statusInboundsList : IListStatusInbound[] = [];
    listStatusOutboundsApi : ListStatusOutboundsApi;
    statusOutboundsList : IListStatusOutbound[] = [];
    showCustomer: boolean = false;
    customersApi : CustomerApi;
    CustomerList : ICustomer[] = [];
    settingsCompanyApi : SettingsCompanyApi;
    constructor() {
        super();
        this.inboundsApi = new InboundApi();
        this.outboundsApi = new OutboundApi();
        this.inboundDetailApi = new InboundDetailsApi("Inbounds");
        this.outboundDetailApi = new OutboundDetailsApi("Outbounds");
        this.listStatusInboundsApi = new ListStatusInboundsApi();
        this.listStatusOutboundsApi = new ListStatusOutboundsApi();
        this.customersApi = new CustomerApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Planning");
    }

    created() {
        this.getPermissions();
        this.getInbounds();
        this.getOutbounds();
        this.getListStatusInbounds();
        this.getListStatusOutbounds();
        this.loadTimeSlots(new Date().toISOString().substring(0, 10), true, "");
        this.getCustomers();
    }

    async getCustomers() {
        this.CustomerList = await this.customersApi.GetCustomersByCompanyId(this.idCompany);
    }

    async getListStatusInbounds() {
        this.statusInboundsList = await this.listStatusInboundsApi.GetListStatusInbounds();
    }

    async getListStatusOutbounds() {
        this.statusOutboundsList = await this.listStatusOutboundsApi.GetListStatusOutbounds();
    }

    async loadTimeSlots(time: string, isDateChanged: boolean, idCompanyDestination: string) {
        const calculator = new TimeSlotCalculator(
            this.inboundsApi.GetInboundsByDate.bind(this.inboundsApi),
            this.outboundsApi.GetOutboundsByDate.bind(this.outboundsApi),
            this.inboundsApi.GetInboundsByDateOtherCompanies.bind(this.inboundsApi),
            this.outboundsApi.GetOutboundsByDateOtherCompanies.bind(this.outboundsApi)
        );

        const hasInboundSelected = !!(this.selectedInbound && this.selectedInbound.id);
        const hasOutboundSelected = !!(this.selectedOutbound && this.selectedOutbound.id);

        // Defaults (cuando vienes “en vacío” desde el calendario)
        let currentCompanySourceId = this.idCompany;
        let currentCompanyDestinationId = idCompanyDestination || "";
        let selectedStartTime: number | undefined;

        if (hasInboundSelected) {
            currentCompanySourceId = this.selectedInbound.idCompanySource || this.idCompany;
            currentCompanyDestinationId = this.selectedInbound.idCompanyDestination || currentCompanyDestinationId;
            selectedStartTime = this.selectedInbound.startTime;
        } else if (hasOutboundSelected) {
            currentCompanySourceId = this.selectedOutbound.idCompanySource || this.idCompany;
            currentCompanyDestinationId = this.selectedOutbound.idCompanyDestination || currentCompanyDestinationId;
            selectedStartTime = this.selectedOutbound.startTime;
        }

        this.availableTimeSlots = await calculator.getAvailableTimeSlots(
            time,
            currentCompanyDestinationId,
            currentCompanySourceId,
            currentCompanyDestinationId,
            selectedStartTime,
            isDateChanged
        );
    }

    async getInbounds() {
        this.inboundList = await this.inboundsApi.GetInboundsSubstractMonth(this.idCompany);
        if (this.showCustomer === false) {
            this.inboundList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
    }

    async getOutbounds() {
        this.outboundList = await this.outboundsApi.GetOutboundsSubstractMonth(this.idCompany);
        if (this.showCustomer === false) {
            this.outboundList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
    }

    async getInboundDetails(inbound: IInbound) {
        this.inboundDetailList = await this.inboundDetailApi.GetInboundDetails(inbound.id);
        this.outboundDetailList = [];
        this.selectedInbound = inbound;
        this.selectedOutbound = {
            id: "",
            idCompanySource: "",
            companySourceName: "",
            idCompanyDestination: "",
            companyDestinationName: "",
            idCustomer: "",
            customerName: "",
            idStatus: "",
            statusName: "",
            code: "",
            dateOut: new Date(),
            dossierNumber: "",
            weight: 0,
            liters: 0,
            deliveriesNumber: 0,
            description: "",
            containerNumber: "",
            sealNumber: "",
            orderNumber: "",
            startTime: 0,
            endTime: 0,
            dateChanged: false,
            entrepot: "",
            agp: "",
            referenceInboundCode: "",
            createdDate: new Date(),
            customerDestination: "",
            codeDestination: "",
            idListTypesOutbounds: "",
            listTypesOutboundsName: "",
            statusColor: "",
            customerDestinationCountry: ""
        };
        this.loadTimeSlots(moment(inbound.dateIn).format('YYYY-MM-DD'), false, inbound.idCompanyDestination);
    }
    
    convertDate(date: Date) {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }

    async getOutboundDetails(outbound: IOutbound) {
        this.outboundDetailList = await this.outboundDetailApi.GetOutboundDetails(outbound.id);
        this.inboundDetailList = [];
        this.selectedInbound = {
            id: "",
            idCompanySource: "",
            companySourceName: "",
            idCompanyDestination: "",
            companyDestinationName: "",
            idCustomer: "",
            customerName: "",
            idStatus: "",
            statusName: "",
            code: "",
            dateIn: new Date(),
            description: "",
            containerNumber: "",
            sealNumber: "",
            weight: 0,
            liters: 0,
            referenceInboundCode: "",
            orderNumber: "",
            startTime: 7,
            endTime: 0,
            dateChanged: false,
            totalValue: 0,
            agp: "",
            arrivalFrom: "",
            codeDestination: "",
            idListTypesInbounds: "",
            listTypesInboundsName: "",
            idListCurrency: "",
            listCurrencyName: "",
            statusColor: "",
            arrivalFromCountry: ""
        };
        this.selectedOutbound = outbound;
        this.loadTimeSlots(moment(outbound.dateOut).format('YYYY-MM-DD'), false, outbound.idCompanyDestination);
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Planning"));
        let settingsCompany = SettingsCompany.Settings.ShowCustomer;
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }
    }

    showWarningMaxSlot(message: string) {
        this.showMessageWarning(message);
    }

    async saveInboundTimeSlot(inbound: IInbound) {
        await this.inboundsApi.UpdateInbound(inbound);
        this.showMessageInfo("Successfully saved.");
    }

    async saveOutboundTimeSlot(outbound: IOutbound) {
        await this.outboundsApi.UpdateOutbound(outbound);
        this.showMessageInfo("Successfully saved.");
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
